module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-36x36-9b2cfdfea636bc4fb159a61f5deef169.png";